import { NgModule } from '@angular/core';
import { OrderProcessComponent } from './order-process.component';

@NgModule({
  declarations: [OrderProcessComponent],
  imports: [
  ],
  exports: [OrderProcessComponent]
})
export class OrderProcessModule { }
